/**
 * マーク・アイコンマスタ画面のマークファイルクラス
 *
 * @export MarkFile
 * @class MarkFile
 */
export class MarkFile {
    constructor(
        public markCode: string,
        public markCodeBranch: string,
        public markName: string,
        public markFileName: string,
        public markFileUrl: string,
        public markGroupCode: string,
        public supplyPromoteMarkDiv: string,
        public startOrderCode: string,
        public startDelivCatalogId: string,
        public endOrderCode: string,
        public endDelivCatalogId: string,
        public delivEndDate: string,
        public registDate: string,
        public fileRegistDate: string
    ) { }
}
